import React from "react";
import { OnboardingPage } from "../../../layouts/OnboardingPage";
import PaymentInfoForm from "./PaymentInfoForm";
import usePaymentInfo from "./usePaymentInfo";
import useAuthState from "../../../hooks/useAuthState";
import { Icon } from "../../../atoms/Icon";
import { Button } from "@blueprintjs/core";
import styles from "../PaymentInfo/PaymentInfo.module.scss";

function PaymentInfo() {
  const paymentInfoProps = usePaymentInfo();
  const { onBackPress } = paymentInfoProps;
  const { isLoggedIn, logout } = useAuthState();

  return (
    <OnboardingPage title="Payment Details">
      <div>
        <button className={styles.btnBack}>
          <Icon
            name={"arrow-left"}
            size={19}
            className={styles.arrowLeft}
            onClick={onBackPress}
          />
          Back
        </button>

        {isLoggedIn && (
          <Button className={styles.btnLogout} onClick={logout}>
            Sign Out
          </Button>
        )}

        <PaymentInfoForm {...paymentInfoProps} />
      </div>
    </OnboardingPage>
  );
}

export default PaymentInfo;
